import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("wr_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401) {
            localStorage.removeItem("wr_token");
            localStorage.removeItem("wr_merchant");
            if (!window.location.pathname.startsWith("/login") && !window.location.pathname.startsWith("/w/")) {
                window.location.href = "/login";
            }
        }
        return Promise.reject(err);
    }
);
